import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  dots: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    background: '#d8dce3',
    transition: 'width 0.15s ease',
    margin: '0.15rem',
  },
  active: {
    width: 18,
    background: '#0b2e59',
  },
}));

export interface ProgressDotsProps {
  index: number;
  total: number;
}

export function ProgressDots({ index, total }: ProgressDotsProps) {
  const classes = useStyles();

  return (
    <span className={classes.dots}>
      {Array.from({ length: total }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <span key={i} className={`${classes.dot} ${i === index ? classes.active : ''}`} />
      ))}
    </span>
  );
}

export default ProgressDots;
